'use client';

import { Archive, Download } from 'lucide-react';
import { useState } from 'react';

import { mutationHeaders, responseMessage } from '../../../components/app-shell';

export function ConversationDataActions({ conversationId }: Readonly<{ conversationId: string }>) {
  const [pending, setPending] = useState<'export' | 'retain' | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function requestExport(): Promise<void> {
    setPending('export');
    setMessage(null);
    setError(null);
    try {
      const response = await fetch(`/api/conversations/${encodeURIComponent(conversationId)}/export`, {
        method: 'POST',
        headers: mutationHeaders(),
        body: '{}',
      });
      if (!response.ok) throw new Error(await responseMessage(response));
      setMessage('会话退出申请已创建。');
    } catch (caught: unknown) {
      setError(caught instanceof Error ? caught.message : '会话退出申请创建失败。');
    } finally {
      setPending(null);
    }
  }

  async function retain(): Promise<void> {
    setPending('retain');
    setMessage(null);
    setError(null);
    try {
      const response = await fetch(`/api/conversations/${encodeURIComponent(conversationId)}/retain`, {
        method: 'POST',
        headers: mutationHeaders(),
        body: '{}',
      });
      if (!response.ok) throw new Error(await responseMessage(response));
      const payload = await response.json() as { retainedUntil: string };
      setMessage(`已保留至 ${new Date(payload.retainedUntil).toLocaleDateString('zh-CN')}。`);
    } catch (caught: unknown) {
      setError(caught instanceof Error ? caught.message : '会话保留失败。');
    } finally {
      setPending(null);
    }
  }

  return <section className="conversation-data-actions" aria-label="会话数据">
    <div>
      <button className="secondary-button" type="button" disabled={pending !== null} onClick={() => void requestExport()}><Download size={15} />{pending === 'export' ? '申请中' : '导出本会话'}</button>
      <button className="secondary-button" type="button" disabled={pending !== null} onClick={() => void retain()}><Archive size={15} />{pending === 'retain' ? '保留中' : '保留 30 天'}</button>
    </div>
    {message && <p className="form-success" role="status">{message}</p>}
    {error && <p className="form-error" role="alert">{error}</p>}
  </section>;
}
